import { useSchoolVisual } from 'applications/GSP/shared/hooks/school';
import defaultSchoolLogoUrl from 'shared/assets/images/components/defaultSchoolLogo/defaultSchoolLogo.svg';

export const useGetSchoolLogoUrl = () => {
  const logoUrl = useSchoolVisual()?.logoUrl;

  return logoUrl || defaultSchoolLogoUrl;
};
